import { SmsActionType } from "../action-types/sms.action.types";

export const setUpdateData = (data: string) => {
  return {
    type: SmsActionType.SET_UPDATE_NEWSMS_LIST,
    payload: data,
  };
};

export const setReduceList = (data: string) => {
  return {
    type: SmsActionType.SET_REDUCE_NEWSMS_DATA,
    payload: data,
  };
};
